import React, { useEffect, useState } from "react";
import "./styles.scss";
import {
  Button,
  ImageComponent,
  InputBox,
  Uploader,
} from "../../../components";
import { imageUpload } from "../../../components/uploader/service/image.service";
import { CheckValidity } from "../../../utils/formValidity";
import { deleteImage } from "../../../components/imageComponent/service/upload.service";

const Index = ({ data, onChange }) => {
  const [formData, setFormData] = useState({
    imageUrl: {
      key: "imageUrl",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "Type your image URL",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });
  const [images, setImages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = async (event, inputIdentity) => {
    const updateCategoryForm = {
      ...formData,
    };

    updateCategoryForm[inputIdentity].value = event;
    let validityRes = await CheckValidity(
      inputIdentity,
      updateCategoryForm[inputIdentity].value,
      updateCategoryForm[inputIdentity].validation
    );

    if (validityRes) {
      updateCategoryForm[inputIdentity].isValid = validityRes.isValid;
      updateCategoryForm[inputIdentity].invalidReason = validityRes.reason;
      updateCategoryForm[inputIdentity].value = event;
      updateCategoryForm[inputIdentity].touched = true;
      console.log("required_validation", validityRes);

      let formIsValid = false;
      for (let inputIdentifier in updateCategoryForm) {
        formIsValid = updateCategoryForm[inputIdentifier].valid && formIsValid;
      }
      console.log("formIsValid", formIsValid);
      setFormData(updateCategoryForm);
    }
  };

  const onClickAdd = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    const updateForm = { ...formData };
    if (updateForm.imageUrl.value === "") {
      setIsLoading(false);
      return;
    }
    let file = {
      url: updateForm.imageUrl.value,
      caption: {
        si: updateForm.imageUrl.value,
        en: updateForm.imageUrl.value,
      },
    };
    setImages([...images, file]);
    onChange([...images, file]);
    setFormData({
      ...formData,
      imageUrl: {
        ...formData.imageUrl,
        value: "",
        isValid: false,
        touched: false,
      },
    });
    setIsLoading(false);
  };

  const onChangeImage = (value) => {
    try {
      console.log("Image Upload Event:", value, { images });
      if (value) {
        let file = {
          url: value.file_url,
          caption: {
            si: value.file_name,
            en: value.file_name,
          },
        };
        setImages([...images, file]);
        onChange([...images, file]);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  const onClickRemoveImage = async (key) => {
    try {
      if (key?.includes("http")) {
        setImages((prev) => {
          return prev.filter((item) => item.caption.si !== key);
        });
        setIsLoading(false);
        return;
      }
      const res = await deleteImage(key);
      console.log("remove image", res);

      setImages((prev) => {
        return prev.filter((item) => item.caption.si !== key);
      });
    } catch (error) {
      console.log("Error in deleting image", error);
    } finally {
      setImages((prev) => {
        return prev.filter((item) => item.caption.si !== key);
      });
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (data?.images?.length > 0) {
      setImages(data.images);
    } else {
      setImages([]);
    }
  }, [data.images]);

  const updateForm = { ...formData };

  return (
    <>
      <div className={"hne-cnw-uploader d-flex flex-column mb-2"}>
        <div className={"hne-cnwu-lable"}>{"Gallery (1024x1024)"}</div>
        <div className="d-flex flex-row align-items-center justify-content-between ">
          <InputBox
            data={updateForm.imageUrl}
            onChange={async (e) => {
              e.preventDefault();
              await handleChange(e.target.value, updateForm.imageUrl.key);
            }}
          />
          <div className="d-flex ml-2">
            <Button
              data={{
                btnName: "Add",
                buttonType: "secondary",
                buttonSize: "md",
                isLoading: isLoading,
                disable:
                  updateForm.imageUrl.value === "" ||
                  !updateForm.imageUrl.isValid,
              }}
              onClick={async (e) => {
                e.preventDefault();
                await onClickAdd(e);
              }}
            />
          </div>
        </div>
        {/* Or */}
        <div
          className={"d-flex flex-row align-items-center"}
          style={{ gap: "7px" }}
        >
          {/* image map */}
          {images?.length > 0 &&
            images?.map((image, index) => (
              <ImageComponent
                data={{ size: "md", imgUrl: image?.url }}
                onClickRemove={() => {
                  console.log("remove image", image);
                  onClickRemoveImage(image?.caption?.si || image?.caption?.en);
                }}
              />
            ))}
          {/* <Uploader
            data={{
              disabled: false,
              isLable: false,
              iconName: "upload-cloud",
            }}
            onChange={onChangeImage}
          /> */}
        </div>
      </div>
    </>
  );
};

export default Index;
